export default (function (_a) {
    var locale = _a.locale, currency = _a.currency, path = _a.path;
    return "/".concat(locale, "/").concat(currency.toLowerCase()).concat(path);
});
